// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-k_gG","advertDetailContactItem__link":"c-k_gH","advertDetailContactItem__stub":"c-k_gJ"};